import React, { useState, useEffect } from "react";
import moment from "moment";
import { useAuth } from "../../Common/Configurations/AuthContext";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import ModifyFlightSearch from "./ModifyFlightSearch";
import DefaultData from "../../CompanyData/DefaultData";
const Flights = () => {
  const { currencies } = useAuth();
  const params = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [pageLoading, setPageLoading] = useState(false);
  const [currency, setCurrency] = useState(DefaultData?.DEFAULTCURRENCY);
  const [flightData, setFlightData] = useState([]);
  const [searchQuery, setSearchQuery] = useState({});
  const [activeTab, setActiveTab] = useState(0);
  const [expandedFlights, setExpandedFlights] = useState({}); // Track which flights have fares expanded
  const [selectedFares, setSelectedFares] = useState({}); // Track selected fare per flight
  const handleCurrencyChange = (newCurrency) => {
    setCurrency(newCurrency);
  };
  /* List Start */
  const [filters, setFilters] = useState({
    airlines: [],
    priceRange: [0, 9999999],
    departureTime: "",
    stops: [],
  });
  const getAirlines = () => {
    const set = new Set();
    flightData.forEach((tab) =>
      tab.dcFlightLegs.forEach((flight) =>
        set.add(flight.dcDisplayLegs[0]?.airlineData?.airline),
      ),
    );
    return Array.from(set);
  };
  const handleFilterChange = (type, value) => {
    setFilters((prev) => {
      if (type === "airlines" || type === "stops") {
        const updated = prev[type].includes(value)
          ? prev[type].filter((v) => v !== value)
          : [...prev[type], value];
        return { ...prev, [type]: updated };
      } else if (type === "priceRange") {
        return { ...prev, priceRange: value };
      } else {
        return { ...prev, [type]: value };
      }
    });
  };
  const applyFilters = (flights) => {
    return flights.filter((flight) => {
      const displayLeg = flight.dcDisplayLegs[0];
      const airline = displayLeg?.airlineData?.airline;
      const stops = displayLeg?.stops;
      const price = flight.totalPrice || 0;
      const departureHour = new Date(
        displayLeg?.startSegment.departureDateTime,
      ).getHours();

      return (
        (filters.airlines.length === 0 || filters.airlines.includes(airline)) &&
        (filters.stops.length === 0 || filters.stops.includes(stops)) &&
        price >= filters.priceRange[0] &&
        price <= filters.priceRange[1] &&
        (!filters.departureTime ||
          (filters.departureTime === "morning" &&
            departureHour >= 5 &&
            departureHour < 12) ||
          (filters.departureTime === "afternoon" &&
            departureHour >= 12 &&
            departureHour < 17) ||
          (filters.departureTime === "evening" &&
            departureHour >= 17 &&
            departureHour < 21) ||
          (filters.departureTime === "night" &&
            (departureHour >= 21 || departureHour < 5)))
      );
    });
  };
  const handleClearFilters = () => {
    setFilters({
      airlines: [],
      priceRange: [0, 9999999],
      departureTime: "",
      stops: [],
    });
  };
  function getTimeFromMins(mins) {
    var h = (mins / 60) | 0,
      m = (mins % 60) | 0;
    var durationformat = h + "h " + m + "m";
    return durationformat;
  }
  const handleToggleFares = (supplierLegId) => {
    setExpandedFlights((prev) => ({
      ...prev,
      [supplierLegId]: !prev[supplierLegId],
    }));
  };
  const handleSelectFare = (
    journeyType,
    flightLeg,
    selectedSupplierPriceId,
  ) => {
    const selectedFare = flightLeg.dcPriceDetails.find(
      (fare) => fare.supplierPriceId === selectedSupplierPriceId,
    );

    if (selectedFare) {
      setSelectedFares((prev) => ({
        ...prev,
        [journeyType]: {
          flightLeg,
          fare: selectedFare,
        },
      }));
    }
  };

  const BindPageData = (searchQuery) => {
    setPageLoading(true);
    GetFlights(searchQuery);
  };
  const GetFlights = async (searchQuery) => {
    var result = await apiService.post(config.SEARCHFLIGHTS, searchQuery);
    if (result.length > 0) {
      console.log("API Result:", result);
      const defaultSelected = {};
      const sortedData = result.map((destination) => {
        const sortedLegs = [...destination.dcFlightLegs].sort(
          (a, b) => a.totalPrice - b.totalPrice,
        );

        const cheapestLeg = sortedLegs[0];
        let matchingFare = null;

        if (cheapestLeg?.dcPriceDetails?.length > 0) {
          matchingFare = [...cheapestLeg.dcPriceDetails].sort(
            (a, b) => a.totalPrice - b.totalPrice,
          )[0];
        }

        if (cheapestLeg && matchingFare && searchQuery.journeyType !== "ONEWAY") {
          defaultSelected[destination.journeyType] = {
            flightLeg: cheapestLeg,
            fare: matchingFare,
          };
        }

        return {
          ...destination,
          dcFlightLegs: sortedLegs,
        };
      });

      setFlightData(sortedData);
      setSelectedFares(defaultSelected);
    } else {
      alert("No flights found");
    }
    setPageLoading(false);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = Object.values(selectedFares).map(({ flightLeg, fare }) => ({
      flightLeg: flightLeg,
      fare: fare,
    }));
    const url = `/flightdetails/${params.adults}/${params.kids}/${params.infants}/${params.isDomestic}`;
    sessionStorage.setItem('flight_booking_data', JSON.stringify({ searchQuery, payload }));
    window.open(url, '_blank');
  };
  const handleBookOneway = (flightLeg, fare) => {
    const payload = [{ flightLeg, fare }];
    const url = `/flightdetails/${params.adults}/${params.kids}/${params.infants}/${params.isDomestic}`;
    sessionStorage.setItem('flight_booking_data', JSON.stringify({ searchQuery, payload }));
    window.open(url, '_blank');
  };
  const handleSearch = (query) => {
    setSearchQuery(query);
    setPageLoading(true);
    BindPageData(query);
  };
  useEffect(() => {
    if (state === null) {
      navigate("/flight/search");
    } else if (params === null) {
      navigate("/flight/search");
    } else if (state.searchQuery === null) {
      navigate("/flight/search");
    } else {
      setSearchQuery(state.searchQuery);
      setPageLoading(true);
      BindPageData(state.searchQuery);
    }
    if (currencies?.length > 0) {
      const userCurrency = DefaultData?.DEFAULTCURRENCY || "INR";
      const defaultCurrency = currencies.find((c) => c.code === userCurrency);
      setCurrency(defaultCurrency);
    }
  }, []);
  return (
    <>
      <div className="container-fluid">
        {/* start page title */}
        <div className="card">
          <ModifyFlightSearch onSearch={handleSearch}></ModifyFlightSearch>
        </div>
        <div className="row">
          <div className="col-3">
            <div className="card">
              <div className="card-header">
                <div className="d-flex mb-0">
                  <div className="flex-grow-1">
                    <h5 className="fs-16">Filters</h5>
                  </div>
                  <div className="flex-shrink-0">
                    <Link
                      onClick={handleClearFilters}
                      className="text-decoration-underline"
                    >
                      Clear All
                    </Link>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div style={{ marginTop: "10px" }}>
                  <p className="text-muted text-uppercase fs-12 fw-medium mb-2">
                    Stops
                  </p>
                  {[0, 1, 2].map((stop) => (
                    <div key={stop}>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={filters.stops.includes(stop)}
                          onChange={() => handleFilterChange("stops", stop)}
                        />
                        {stop} Stop{stop !== 1 ? "s" : ""}
                      </label>
                    </div>
                  ))}
                </div>
                <div style={{ marginTop: "10px" }}>
                  <p className="text-muted text-uppercase fs-12 fw-medium mb-2">
                    Departure Time
                  </p>
                  {["morning", "afternoon", "evening", "night"].map((slot) => (
                    <div key={slot}>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <input
                          type="radio"
                          name="departureTime"
                          checked={filters.departureTime === slot}
                          onChange={() =>
                            handleFilterChange("departureTime", slot)
                          }
                        />
                        {slot.charAt(0).toUpperCase() + slot.slice(1)}
                      </label>
                    </div>
                  ))}
                </div>
                <div style={{ marginTop: "10px" }}>
                  <p className="text-muted text-uppercase fs-12 fw-medium mb-2">
                    Price Range
                  </p>
                  <input
                    type="range"
                    min={0}
                    max={9999999}
                    value={filters.priceRange[1]}
                    onChange={(e) =>
                      handleFilterChange("priceRange", [
                        0,
                        parseInt(e.target.value),
                      ])
                    }
                  />
                  <div>Up to INR {filters.priceRange[1]}</div>
                </div>
                <div style={{ marginTop: "10px" }}>
                  <p className="text-muted text-uppercase fs-12 fw-medium mb-2">
                    Airlines
                  </p>
                  {getAirlines().map((airline, idx) => (
                    <div key={idx}>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={filters.airlines.includes(airline)}
                          onChange={() =>
                            handleFilterChange("airlines", airline)
                          }
                        />
                        {airline}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {/* end card */}
          </div>
          {pageLoading === true ? (
            <div className="col-9">
              <div className="card">
                <div className="card-body">
                  <div className="text-center">
                    <img
                      src="/assets/images/loader.webp"
                      width={"64px"}
                      height={"64px"}
                    ></img>
                    Loading, Please wait...
                  </div>
                </div>
              </div>{" "}
            </div>
          ) : (
            <div className="col-9">
              <div className="card">
                <div className="card-header">
                  <div className="row align-items-center justify-content-between">
                    <div className="col-md-12">
                      <ul
                        className="nav nav-pills arrow-navtabs nav-success card-header-tabs border-bottom-0"
                        role="tablist"
                      >
                        {flightData.length > 0 &&
                          flightData.map((item, index) => (
                            <li className="nav-item">
                              <a
                                className={`nav-link fw-semibold ${activeTab === index ? "active text-black" : ""}`}
                                key={index}
                                onClick={() => setActiveTab(index)}
                              >
                                {item.locationFrom} - {item.locationTo}
                                <span className="align-middle rounded-pill ms-1">
                                  {item.dcFlightLegs.length} flights
                                </span>
                              </a>
                            </li>
                          ))}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive table-card mb-1">
                    <table className="table table-nowrap align-middle" id="orderTable">
                      <thead className="text-muted table-light">
                        <tr className="text-uppercase text-center">
                          <th>Airline</th>
                          <th>Departure</th>
                          <th>Duration</th>
                          <th>Arrival</th>
                          <th>Fares</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {applyFilters(
                          (flightData.length > 0 && flightData[activeTab]?.dcFlightLegs) || [],
                        )?.map((flightLeg, idx) => {
                          const journeyType = flightData[activeTab]?.journeyType;
                          const isOneway = searchQuery?.journeyType === "ONEWAY";
                          // isSelected controls card border + SELECT/SELECTED button — always false for ONEWAY
                          const isSelected = !isOneway && selectedFares[journeyType]?.flightLeg?.supplierLegId === flightLeg.supplierLegId;
                          // thisFareSelected tracks fare clicks for ONEWAY to update activeFare without showing card-selected state
                          const thisFareSelected = selectedFares[journeyType]?.flightLeg?.supplierLegId === flightLeg.supplierLegId;

                          const cheapestFare = flightLeg.dcPriceDetails.reduce(
                            (min, curr) => (curr.totalPrice ?? Infinity) < (min.totalPrice ?? Infinity) ? curr : min,
                            flightLeg.dcPriceDetails[0]
                          );

                          const selectedFare = thisFareSelected ? selectedFares[journeyType]?.fare : null;
                          const activeFare = selectedFare || cheapestFare;
                          // For ONEWAY: highlight only explicitly clicked fare; nothing highlighted by default
                          const highlightedFare = isOneway ? selectedFare : activeFare;

                          return (
                            <tr key={flightLeg.supplierLegId || idx}>
                              <td colSpan={6} className="p-2 border-0">
                                <div className={`card mb-2 shadow-sm border ${isSelected ? 'border-success' : 'border-light'}`} style={{ borderRadius: '12px' }}>
                                  <div className="card-body p-0"> {/* Changed p-3 to p-0 for better edge-to-edge control */}
                                    {/* MAIN INFORMATION ROW - Static and always visible */}
                                    <div className="p-3">
                                      <div className="row align-items-center text-center g-0">

                                        {/* Flight legs – one row per display leg (outbound + return for round trips) */}
                                        <div className="col-md-8">
                                          {flightLeg.dcDisplayLegs.map((displayLeg, legIdx) => (
                                            <div key={legIdx} className={`row align-items-center text-center g-0${legIdx > 0 ? ' border-top pt-2 mt-2' : ''}`}>
                                              {/* Airline */}
                                              <div className="col-3">
                                                <img
                                                  src={`/assets/images/airlinelogos/${displayLeg?.airlineData?.airlineCode}.png`}
                                                  alt=""
                                                  className="mb-1"
                                                  style={{ width: "35px", height: "35px", objectFit: 'contain' }}
                                                />
                                                <div className="fw-bold small text-uppercase text-dark">
                                                  {displayLeg?.airlineData?.airlineCode} {displayLeg?.airlineData?.flightNumber}
                                                </div>
                                              </div>
                                              {/* Departure */}
                                              <div className="col-3">
                                                <div className="fs-17 fw-bold text-dark">{moment(displayLeg?.startSegment?.departureDateTime).format("HH:mm")}</div>
                                                <div className="text-muted small fw-medium">{displayLeg?.startSegment?.airportCode}</div>
                                              </div>
                                              {/* Duration/Stops */}
                                              <div className="col-3">
                                                <div className="small fw-medium text-muted">{getTimeFromMins(displayLeg?.totalDuration)}</div>
                                                <div className="d-flex align-items-center justify-content-center my-1">
                                                  <div style={{ height: '1px', backgroundColor: '#e2e5e8', width: '40px' }}></div>
                                                  <i className="ri-plane-fill mx-1 text-muted" style={{ fontSize: '12px' }}></i>
                                                  <div style={{ height: '1px', backgroundColor: '#e2e5e8', width: '40px' }}></div>
                                                </div>
                                                <div className="small text-info fw-bold" style={{ fontSize: '10px' }}>
                                                  {displayLeg?.stops === 0 ? "NON-STOP" : `${displayLeg?.stops} STOP(S)`}
                                                </div>
                                              </div>
                                              {/* Arrival */}
                                              <div className="col-3">
                                                <div className="fs-17 fw-bold text-dark">{moment(displayLeg?.endSegment?.arrivalDateTime).format("HH:mm")}</div>
                                                <div className="text-muted small fw-medium">{displayLeg?.endSegment?.airportCode}</div>
                                              </div>
                                            </div>
                                          ))}
                                        </div>

                                        {/* 5. Active Fare Price */}
                                        <div className="col-md-2 border-start d-flex flex-column align-items-center justify-content-center">
                                          {/* 1. Fare Badge */}
                                          <div className="badge bg-success-subtle text-success mb-1" style={{ fontSize: '10px' }}>
                                            {activeFare?.fareIdentifier}
                                          </div>

                                          {/* 2. Main Price */}
                                          <div className="fs-18 fw-bold text-primary mb-2">
                                            {currency} {activeFare?.totalPrice?.toLocaleString()}
                                          </div>

                                          {/* 3. Baggage & Seats Row */}
                                          <div className="d-flex gap-3 justify-content-center align-items-center mt-2">
                                            {/* Cabin Baggage */}
                                            <div className="d-flex align-items-center" title="Cabin Baggage">
                                              <i className="ri-briefcase-line text-muted me-1" style={{ fontSize: '14px' }}></i>
                                              <span className="fw-bold text-dark" style={{ fontSize: '11px' }}>
                                                {activeFare?.cabinBaggage || '7kg'}
                                              </span>
                                            </div>

                                            {/* Check-in Baggage */}
                                            <div className="d-flex align-items-center" title="Check-in Baggage">
                                              <i className="ri-luggage-cart-line text-muted me-1" style={{ fontSize: '14px' }}></i>
                                              <span className="fw-bold text-dark" style={{ fontSize: '11px' }}>
                                                {activeFare?.checkinBag || '15kg'}
                                              </span>
                                            </div>

                                            {/* Seats Remaining */}
                                            <div className="d-flex align-items-center" title="Seats Left">
                                              <i className="ri-armchair-line text-danger me-1" style={{ fontSize: '14px' }}></i>
                                              <span className="fw-bold text-danger me-1" style={{ fontSize: '11px' }}>
                                                {flightLeg?.noOfSeats}
                                              </span>
                                              <span className="fw-bold text-dark" style={{ fontSize: '11px' }}>Seats</span>
                                            </div>
                                          </div>
                                        </div>

                                        {/* 6. Action Button */}
                                        <div className="col-md-2 ps-2 d-flex flex-column justify-content-center align-items-center">
                                          {isOneway ? (
                                            <button
                                              className="btn btn-sm w-100 rounded-pill fw-bold btn-primary"
                                              onClick={() => handleBookOneway(flightLeg, activeFare)}
                                            >
                                              Book
                                            </button>
                                          ) : (
                                            <button
                                              className={`btn btn-sm w-100 rounded-pill fw-bold ${isSelected ? 'btn-success' : 'btn-primary'}`}
                                              onClick={() => handleSelectFare(journeyType, flightLeg, activeFare.supplierPriceId)}
                                            >
                                              {isSelected ? "SELECTED" : "SELECT"}
                                            </button>
                                          )}

                                          {/* VIEW DETAILS - Now strictly below */}
                                          <button
                                            className="btn btn-link btn-sm mt-1 text-decoration-none shadow-none text-muted"
                                            style={{ fontSize: '11px' }}
                                            data-bs-toggle="modal"
                                            data-bs-target={`#flight${flightLeg.supplierLegId}`}
                                          >
                                            View Details
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                    {/* FARE FAMILY STRIP - Scrollable Only */}
                                    <div className="bg-light border-top py-2 px-3">
                                      <div className="d-flex align-items-center">
                                        <span className="small text-muted fw-bold text-uppercase me-2" style={{ fontSize: '10px', minWidth: '75px' }}>
                                          Other Fares:
                                        </span>

                                        <div className="d-flex flex-nowrap overflow-auto hide-scrollbar" style={{ gap: "8px" }}>
                                          {/* 1. Display first 4 fares directly */}
                                          {flightLeg.dcPriceDetails.slice(0, 4).map((fare, i) => {
                                            const isThisFareActive = highlightedFare?.supplierPriceId === fare.supplierPriceId;
                                            return (
                                              <div
                                                key={i}
                                                onClick={() => handleSelectFare(journeyType, flightLeg, fare.supplierPriceId)}
                                                className={`flex-shrink-0 px-3 py-2 rounded border text-center transition-all ${isThisFareActive ? 'bg-white border-primary border-2 shadow-sm' : 'bg-white text-muted border-light'
                                                  }`}
                                                style={{ cursor: 'pointer', minWidth: '120px', display: 'flex', flexDirection: 'column' }}
                                              >
                                                <div className={`text-uppercase mb-0 ${isThisFareActive ? 'text-primary fw-bold' : 'text-muted'}`} style={{ fontSize: '10px' }}>
                                                  {fare.fareIdentifier}
                                                </div>
                                                <div className="fw-bold text-dark" style={{ fontSize: '13px' }}>
                                                  {currency} {fare.totalPrice?.toLocaleString()}
                                                </div>
                                              </div>
                                            );
                                          })}

                                          {/* 2. Show '+ More' button if there are more than 4 fares */}
                                          {flightLeg.dcPriceDetails.length > 4 && (
                                            <div
                                              className="flex-shrink-0 px-3 py-2 rounded border border-info bg-info-subtle text-center d-flex flex-column justify-content-center"
                                              style={{ cursor: 'pointer', minWidth: '100px' }}
                                              data-bs-toggle="modal"
                                              data-bs-target={`#moreFares${flightLeg.supplierLegId}`}
                                            >
                                              <div className="text-info fw-bold" style={{ fontSize: '11px' }}>
                                                +{flightLeg.dcPriceDetails.length - 4} MORE
                                              </div>
                                              <div className="text-info small" style={{ fontSize: '10px' }}>View All</div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>

                                    {/* 3. The Popup Modal (Place this outside the <tbody> or at the end of the component) */}
                                    <div className="modal fade" id={`moreFares${flightLeg.supplierLegId}`} tabIndex="-1" aria-hidden="true">
                                      <div className="modal-dialog modal-dialog-centered">
                                        <div className="modal-content">
                                          <div className="modal-header border-0 pb-0">
                                            <h6 className="modal-title fw-bold">All Fare Options</h6>
                                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                          </div>
                                          <div className="modal-body">
                                            <div className="list-group list-group-flush">
                                              {flightLeg.dcPriceDetails.map((fare, i) => (
                                                <button
                                                  key={i}
                                                  className="list-group-item list-group-item-action d-flex justify-content-between align-items-center py-3"
                                                  onClick={() => {
                                                    handleSelectFare(journeyType, flightLeg, fare.supplierPriceId);
                                                    // Optional: Close modal automatically on select
                                                  }}
                                                  data-bs-dismiss="modal"
                                                >
                                                  <span className="fw-medium text-uppercase text-muted small">{fare.fareIdentifier}</span>
                                                  <span className="fw-bold text-primary">{currency} {fare.totalPrice?.toLocaleString()}</span>
                                                </button>
                                              ))}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div

                                className="modal fade"

                                id={`flight${flightLeg.supplierLegId}`}

                                tabIndex="-1"

                                role="dialog"

                                aria-hidden="true"

                              >

                                <div className="modal-dialog modal-lg modal-dialog-centered">

                                  <div className="modal-content">

                                    <div className="modal-header">

                                      <h5 className="modal-title">

                                        Flight Details

                                      </h5>

                                      <button

                                        type="button"

                                        className="btn-close"

                                        data-bs-dismiss="modal"

                                        aria-label="Close"

                                      />

                                    </div>

                                    <div className="modal-body">

                                      <div className="flight-details">

                                        <div className="row align-items-center trip-title mb-3">

                                          <div className="col-sm-auto text-center text-sm-start">

                                            <span className="m-0 fs-14">

                                              {

                                                flightLeg.dcDisplayLegs?.[0]

                                                  ?.startSegment?.city

                                              }

                                            </span>

                                          </div>

                                          <div className="col-auto text-black-50 text-center trip-arrow">

                                            ➝

                                          </div>

                                          <div className="col-sm-auto text-center text-sm-start">

                                            <span className="m-0 fs-14">

                                              {

                                                flightLeg.dcDisplayLegs?.[0]

                                                  ?.endSegment?.city

                                              }

                                            </span>

                                          </div>

                                          <div className="col-sm-auto text-center text-sm-start">

                                            <span className="m-0 fs-14">

                                              Departure:{" "}

                                              {moment(

                                                flightLeg.dcDisplayLegs?.[0]

                                                  ?.startSegment

                                                  ?.departureDateTime,

                                              ).format("Do MMM YY HH:mm")}

                                            </span>

                                          </div>

                                          <div className="col-sm-auto text-center text-sm-start">

                                            <span className="m-0 fs-14">

                                              Arrival:{" "}

                                              {moment(

                                                flightLeg.dcDisplayLegs?.[0]

                                                  ?.endSegment?.arrivalDateTime,

                                              ).format("Do MMM YY HH:mm")}

                                            </span>

                                          </div>

                                        </div>

                                        <div className="tab-content my-3">

                                          {flightLeg.dcSegments.map((seg) => (

                                            <>

                                              <div className="row flex-row pt-4 px-md-4">

                                                <div className="col-sm-3 text-center d-lg-flex company-info">

                                                  <span className="align-middle">

                                                    <img

                                                      className="img-fluid"

                                                      alt=""

                                                      src={`/assets/images/airlinelogos/${seg?.tFAirlineData?.airlineCode}.png`}

                                                    />

                                                  </span>

                                                  <span className="align-middle ms-lg-2">

                                                    <span className="d-block text-dark">

                                                      {seg.tFAirlineData?.airline}

                                                    </span>

                                                    <small className="text-muted d-block">

                                                      {seg.tFAirlineData?.equimentType}-

                                                      {seg.tFAirlineData?.flightNumber}

                                                    </small>

                                                  </span>

                                                </div>

                                                <div className="col-sm-3 text-center time-info mt-3 mt-sm-0">

                                                  <span className="text-dark">

                                                    {moment(

                                                      seg.tFDepartureData.departureDateTime,

                                                    ).format("HH:mm")}

                                                  </span>

                                                  <small className="text-muted d-block">

                                                    {seg.tFDepartureData.airportName},{" "}

                                                    {seg.tFDepartureData.city},{" "}

                                                    {seg.tFDepartureData.terminal}

                                                  </small>

                                                </div>

                                                <div className="col-sm-3 text-center time-info mt-3 mt-sm-0">

                                                  <span className="text-dark">

                                                    {getTimeFromMins(

                                                      seg?.tFAirlineData?.duration,

                                                    )}

                                                  </span>

                                                  <small className="text-muted d-block">

                                                    Duration

                                                  </small>

                                                </div>

                                                <div className="col-sm-3 text-center time-info mt-3 mt-sm-0">

                                                  <span className="text-dark">

                                                    {moment(

                                                      seg.tFArrivalData.arrivalDateTime,

                                                    ).format("HH:mm")}

                                                  </span>

                                                  <small className="text-muted d-block">

                                                    {seg.tFArrivalData.airportName},{" "}

                                                    {seg.tFArrivalData.city},{" "}

                                                    {seg.tFArrivalData.terminal}

                                                  </small>

                                                </div>

                                              </div>

                                              {seg?.tFAirlineData?.connectingTime !==

                                                0 && (

                                                  <div className="row flex-row pt-4 px-md-4">

                                                    <div className="col-sm-3 text-center d-lg-flex company-info">

                                                      <span className="badge bg-success">

                                                        Connecting Time:{" "}

                                                        {getTimeFromMins(

                                                          seg?.tFAirlineData

                                                            ?.connectingTime,

                                                        )}

                                                      </span>

                                                    </div>

                                                  </div>

                                                )}

                                            </>

                                          ))}

                                        </div>

                                      </div>

                                    </div>

                                  </div>

                                </div>

                              </div>

                              </td>
                            </tr>
                            
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* end col */}
      </div>
      {pageLoading === false && searchQuery?.journeyType !== "ONEWAY" ? (
        Object.keys(selectedFares).length > 0 ? (
          <div
            className="round-trip-fare fixed-bottom bg-dark shadow-md text-light"
            style={{ backgroundColor: DefaultData?.THEMECOLOR1 }}
          >
            <div className="container p-2 p-sm-4">
              <div className="row align-items-center">
                <div className="col-9">
                  <div className="row">
                    {Object.entries(selectedFares).map(([journeyType, sf]) => (
                      <div
                        key={journeyType}
                        className={
                          "border-right border-dark" +
                            Object.keys(selectedFares).length >
                            1
                            ? "col-sm-6"
                            : "col-sm-12"
                        }
                      >
                        {sf.flightLeg?.dcDisplayLegs.map((displayLeg, legIdx) => (
                          <div key={legIdx} className={`row align-items-center flex-row${legIdx > 0 ? ' border-top border-secondary pt-1 mt-1' : ''}`}>
                            <div className="col col-sm-3 col-md-3 text-center d-lg-flex company-info">
                              <span className="align-middle d-none d-sm-block">
                                <img
                                  className="img-fluid me-2"
                                  alt=""
                                  width={"30px"}
                                  height={"30px"}
                                  src={`/assets/images/airlinelogos/${displayLeg?.airlineData?.airlineCode}.png`}
                                />
                              </span>
                              <span className="align-middle ml-lg-2">
                                <span className="d-block text-1">{displayLeg?.airlineData?.airline}</span>
                                <small className="text-white-50 d-block">
                                  {displayLeg?.airlineData?.airlineCode}-{displayLeg?.airlineData?.flightNumber}
                                </small>
                              </span>
                            </div>
                            <div className="col col-sm-3 col-md-3 text-center time-info">
                              <span className="text-4">
                                {new Date(displayLeg?.startSegment?.departureDateTime).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
                              </span>
                              <small className="text-white-50 d-none d-lg-block">{displayLeg?.startSegment?.city}</small>
                            </div>
                            <div className="col col-sm-3 col-md-3 text-center time-info">
                              <span className="text-4">
                                {new Date(displayLeg?.endSegment?.arrivalDateTime).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
                              </span>
                              <small className="text-white-50 d-none d-lg-block">{displayLeg?.endSegment?.city}</small>
                            </div>
                            <div className="col-sm-3 col-md-3 text-center d-none d-md-block time-info">
                              <span className="text-1">
                                {Math.floor(displayLeg?.totalDuration / 60)}h {displayLeg?.totalDuration % 60}m
                              </span>
                              <small className="text-white-50 d-block">
                                {displayLeg?.stops === 0 ? "Non Stop" : `${displayLeg?.stops} Stop(s)`}
                              </small>
                            </div>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col-3">
                  <div className="row align-items-center">
                    <div className="col-12 col-md-6 text-light text-center text-6 price">
                      <span className="text-1 text-white-50 d-none d-lg-block">
                        Total Fare:{" "}
                      </span>
                      {currency}{" "}
                      {Object.values(selectedFares)
                        .reduce(
                          (sum, sf) => sum + (sf.fare?.totalPrice || 0),
                          0,
                        )
                        .toFixed(2)}
                    </div>
                    <div className="col-12 col-md-6 text-center mt-2 mt-md-0 btn-book">
                      <button
                        onClick={handleSubmit}
                        className="btn btn-sm btn-primary px-sm-2 px-lg-3"
                      >
                        <i className="fas fa-shopping-cart d-block d-lg-none" />
                        <span className="d-none d-lg-block">Book Now</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )
      ) : (
        ""
      )}
    </>
  );
};

export default Flights;
